/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelArCallRecord.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/ar-call-record";

export class AutogenModelArCallRecord<RowType extends ModelRow> extends Endpoint<RowType, RowArCallRecordFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowArCallRecord extends ModelRow<RowArCallRecordFields> {
	constructor(values?: Partial<RowArCallRecordFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowArCallRecordFields {
	action_code_id: string;
	attach_filename: string;
	attachment: string;
	call_date: Date;
	call_detail: string;
	caller_user_id: string;
	closed_date: Date;
	collection_amt: number;
	collection_amt_c: string;
	collection_amt_d: Date;
	collection_amt_n: number;
	collection_amt_r: number;
	company_id: string;
	"contact.id": string;
	contact_name: string;
	customer_id: string;
	deposit_no: string;
	email: string;
	id: string;
	name: string;
	nxt_action_code: string;
	nxt_action_date: Date;
	phone: string;
	remark: string;
	status: string;
	title: string;
}

